import React, { forwardRef, Fragment, useRef, useState } from "react";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import Collapse from "../../CommonComponents/Collapse";
import Button from "../../Button";
import InputField from "../../CommonComponents/InputField";
import { libTypeIds, RESULT_STATUS } from "../../../constants";
import useAxiosPrivate from "../../../Hooks/useAxiosPrivate";
import useAuth from "../../../Hooks/useAuth";
import { useParams } from "react-router-dom";
import ChapterItem, { GridIcon } from "./ChapterItem";
import Modal from "../../CommonComponents/Modal";
import ModalBody from "../../CommonComponents/ModalBody";
import { useEffect } from "react";
import { getContentType, getDataFromStorage } from "../../../util";
import Tooltip from "../../CommonComponents/Tooltip";
import Loading from "../../Notification-Loading/Loading/Loading";
import constants from "../../../constants";
const AddIcon = (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.66829 0.834961V12.5016M0.834961 6.66829H12.5016"
      stroke="#344054"
      strokeWidth="1.67"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></path>
  </svg>
);

const Chapter = forwardRef(
  (
    {
      item = {},
      onDelete = null,
      onChange = null,
      onAddChapterItem = null,
      onBlurField = null,
      onReorderChapterItem = null,
      onDeleteItem = null,
      onEditItem = null,
      onUpdateItemSetting = null,
      index = 0,
      onChangePublishData = null,
      onToggleChapter = null,
      isOpen = false,
      setToastMessage = null,
      setToastType = null,
      setToastOpen = null,
      isSharedLP = 0,
    },
    ref,
  ) => {
    const axios = useAxiosPrivate();
    const { setShowNotify, navigate } = useAuth();
    const { id, lpid, mid } = useParams();

    // const [open, setOpen] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [isDeletableChapter, setIsDeletableChapter] = useState(true);
    const [isDeleting, setIsDeleting] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const prevOrderRef = useRef([]);

    useEffect(() => {
      setIsDeletableChapter(
        item.chapterData.some(
          (data) => data.published === 1 || data.published === true,
        ),
      );
    }, [item]);
    const isSelfPacedBatch =
        parseInt(sessionStorage.getItem("batchType"), 10) ===
        constants.BATCH_TYPE.SELF;
    const onOpenChapter = () => {
      if (!item.chapterName || !Number.isInteger(+item.chapterId)) {
        setToastOpen(true);
        setToastMessage("Please enter chapter name before expanding.");
        setToastType("error");
        return;
      }
      onToggleChapter && onToggleChapter(item.chapterId);
    };

    const onDeleteChapter = (event, item) => {
      event.stopPropagation();
      setOpenModal(true);
    };

    const onConfirmDeleteChapter = async (item) => {
      if (item.status === "old") {
        try {
          setIsDeleting(true);
          const { data } = await axios.delete(
            `node/admin/module/${item.chapterId}?lpId=${lpid}&parentModId=${mid}&scope=chapter`,
          );
          if (data.resultCode === RESULT_STATUS.SUCCESS) {
            setOpenModal(false);
            setToastOpen(true);
            setToastMessage("The chapter deleted successfully.");
            setToastType("success");
            onDelete && onDelete(item);
          } else
            throw new Error(
              data.msg ?? `Unable to delete chapter. Please try again later`,
            );
        } catch (error) {
          console.log("error in delete module", error);
          let isUnAuth = error.message.includes("403");
          if (isUnAuth) {
            setShowNotify({
              isUnAuth,
              title: "Warning !",
              msg: "You have been logged-out due to inactivity. Login again.",
              show: true,
            });
            setOpenModal(false);
          } else {
            setToastOpen(true);
            setToastMessage(`Unable to delete chapter. Please try again later`);
            setToastType("error");
          }
        } finally {
          setIsDeleting(false);
        }
      } else {
        onDelete && onDelete(item);
        setOpenModal(false);
      }
    };

    const reorderChapterItem = async (from, to, canCallApi = false) => {
      console.log("from", from, "to", to, "item", item);

      if (isSharedLP === 1) {
        return (
          setToastOpen(true),
          setToastMessage("Reorder is not allowed in shared learning path."),
          setToastType("error")
        );
      }

      if (from === to) return;

      const copyModuleDetails = JSON.parse(JSON.stringify(item));
      const chapterData = JSON.parse(JSON.stringify(item.chapterData));
      let minOrderno = chapterData[0]?.orderno || 1;

      const [movedItem] = chapterData.splice(from, 1);
      console.log("movedItem", movedItem);

      chapterData.splice(to, 0, movedItem);
      console.log("chapterData", chapterData);

      const topId = chapterData[to - 1]?.lpcId ?? null;
      const bottomId = chapterData[to + 1]?.lpcId ?? null;

      const updatedChapterData = chapterData.map((chapter, index) => ({
        ...chapter,
        orderno: minOrderno++,
      }));

      // const payload = updatedChapterData.map((c) => ({
      //   moduleId: c.lpcId,
      //   orderno: c.orderno,
      // }));      
      onReorderChapterItem &&
        onReorderChapterItem(mid, item.chapterId, updatedChapterData);
      if (canCallApi && Number.isInteger(+movedItem.lpcId)) {
        try {
          setIsLoading(true);
          const { data } = await axios.post(
            `/node/admin/learningpath/${lpid}/reorder-modules`,
            {
              // modules: payload,
              lpId: lpid,
              scope: "chapter-data",
              chapterId: item.chapterId, //child parent id
              parentModuleId: mid,
              configId:+movedItem.lpcId,
              topId,
              bottomId,
            },
          );
          if (data.resultCode !== RESULT_STATUS.SUCCESS) {
            throw new Error(
              data.msg ??
              `Unable to reorder chapter items. Please try again later`,
            );
          } else {
            setToastMessage("Chapter items reordered successfully.");
            setToastType("success");
            setToastOpen(true);
          }
        } catch (error) {
          console.log("error in reorder module", error);
          onReorderChapterItem(mid, item.chapterId, prevOrderRef.current);
          let isUnAuth = error.message.includes("403");
          if (isUnAuth) {
            setShowNotify({
              isUnAuth,
              title: "Warning !",
              msg: "You have been logged-out due to inactivity. Login again.",
              show: true,
            });
            return;
          }
          setToastMessage(
            "Unable to reorder chapter items. Please try again later.",
          );
          setToastType("error");
          setToastOpen(true);
        } finally {
          setIsLoading(false);
        }
      }
    };

    const onEditChapterItem = (chapterData) => {
      let libtype = chapterData.libTypeId;
      let isVideoqns = chapterData.videoAssessment;
      onEditItem && onEditItem(item.chapterId, chapterData);
      let queryStrings = `?selectable=true&published=${chapterData.published ?? 0
        }&lpId=${lpid}&moduleId=${mid}&chapterId=${item.chapterId}&lpcId=${chapterData.lpcId
        }${id ? `&bId=${id}` : ""}${libtype == libTypeIds.DESCRIPTIVE ? isVideoqns ? "&isVideoInterview=true" : "&isVideoInterview=false" : ""}`;
      if (chapterData.libTypeId === libTypeIds.CONTENT) {
        const contentType = getContentType(chapterData.description);
        if (contentType === "editor")
          navigate(
            `/library/${chapterData.libTypeId}/contententry/${chapterData.libId}${queryStrings}`,
          );
        else
          navigate(
            `/library/${chapterData.libTypeId}/questions/${chapterData.libId}${queryStrings}`,
          );
      } else if (chapterData.libTypeId === libTypeIds.ASSIGNMENT) {
        navigate(
          `/library/${chapterData.libTypeId}/assignment/${chapterData.libId}${queryStrings}`,
        );
      } else {
        navigate(
          `/library/${chapterData.libTypeId}/test/${chapterData.testId}${queryStrings}`,
        );
      }
    };

    const onDeleteChapterItem = async (chapterData) => {
      onDeleteItem && onDeleteItem(item.chapterId, chapterData);
    };

    const onBlurItemSetting = async (lpcId, item = {}, isPublish = false) => {
      try {
        const { data } = await axios.put(
          `node/admin/learningpath/${lpid}/module/${mid}/config/${lpcId}`,
          {
            ...item,
            scope: isPublish ? "publish" : "update",
            bId: isPublish ? id : null,
          },
        );
        return data;
      } catch (error) {
        console.error("error in update item setting", error);

        let isUnAuth = error.message.includes("403");
        setShowNotify({
          isUnAuth,
          title: isUnAuth ? "Warning !" : "Error !",
          msg: isUnAuth
            ? "You have been logged-out due to inactivity. Login again."
            : `Unable to update ${item.libTypeId === libTypeIds.ASSIGNMENT
              ? "assignment"
              : item.libTypeId === libTypeIds.CONTENT
                ? "content"
                : "test"
            }. Please try again later`,
          show: true,
        });
      }
    };

    const onPublish = async (item) => { };

    return (
      <Collapse
        className="admin-path-module-chapter-container"
        open={isOpen}
        onToggle={() => onOpenChapter(item.chapterId)}
        isDeletable={!isDeletableChapter}
        onDelete={(event) => onDeleteChapter(event, item)}
        ref={ref}
        isSharedLP={isSharedLP}
        title={
          <div className="admin-path-module-chapter-title-wrapper">
            <GridIcon className="admin-path-module-chapter-reorder-icon" />
            <Tooltip title={item.chapterName}>
              <InputField
                name="chapterName"
                value={item.chapterName ?? "Chapter"}
                placeholder="Chapter name"
                className="admin-path-module-chapter-title"
                onChange={(event) => {
                  // event.stopPropagation();
                  onChange(
                    item.chapterId,
                    event.target.name,
                    event.target.value,
                  );
                }}
                onKeyDown={(event) => {
                  // event.stopPropagation();
                  if (
                    event.code === "Enter" &&
                    Number.isInteger(+item.chapterId) &&
                    item.chapterName
                  ) {
                    onOpenChapter();
                  }
                }}
                destructive={
                  !item.chapterName || !Number.isInteger(+item.chapterId)
                }
                onBlur={(event) => {
                  // event.stopPropagation();
                  onBlurField(item);
                }}
              />
            </Tooltip>
          </div>
        }
        utilsComponent={
          <div className="admin-path-module-chapter-util-component-wrapper">
            <InputField
              name="duedays"
              label="Day/s"
              value={item.duedays ?? ""}
              type="number"
              placeholder="Due"
              className="admin-path-module-chapter-title admin-path-module-chapter-duedays"
              onChange={(event) => {
                event.stopPropagation();
                onChange(item.chapterId, event.target.name, event.target.value);
              }}
              onBlur={(event) => {
                event.stopPropagation();
                onBlurField(item);
              }}
              disabled={isSharedLP === 1}
            />
          </div>
        }
      >
        <DndProvider backend={HTML5Backend}>
          <div>
            {item.chapterData
              ?.sort((a, b) => a.orderno - b.orderno)
              .map(
                (item1, childIndex) =>
                  item1.lpcId && (
                    <ChapterItem
                      key={item1.lpcId}
                      item={item1}
                      chapterId={item.chapterId}
                      index={childIndex}
                      reorder={reorderChapterItem}
                      onDragStart={(event) => {
                        prevOrderRef.current = item1.chapterData;
                      }}
                      parentIndex={index}
                      onDelete={onDeleteChapterItem}
                      onEdit={onEditChapterItem}
                      bId={id}
                      onPublish={onPublish}
                      onUpdateSetting={onUpdateItemSetting}
                      onBlurSetting={onBlurItemSetting}
                      onChangePublishData={onChangePublishData}
                      setToastMessage={setToastMessage}
                      setToastType={setToastType}
                      setToastOpen={setToastOpen}
                      isSharedLP={isSharedLP}
                    />
                  ),
              )}
          </div>
        </DndProvider>
        {isSharedLP === 0 && (
          <div className="admin-path-module-chapter-detail-btn-wrapper">
            <Button
              size="sm"
              hierarchy={{ type: "linkGrey", buttonText: "Content" }}
              icon={{
                type: "leading",
                icon: AddIcon,
              }}
              onClick={() =>
                onAddChapterItem(item.chapterId, libTypeIds.CONTENT)
              }
            />
            <Button
              size="sm"
              hierarchy={{ type: "linkGrey", buttonText: "Assignment" }}
              icon={{
                type: "leading",
                icon: AddIcon,
              }}
              onClick={() =>
                onAddChapterItem(item.chapterId, libTypeIds.ASSIGNMENT)
              }
            />
            {isLoading && <Loading />}
            <Button
              size="sm"
              hierarchy={{ type: "linkGrey", buttonText: "MCQ Test" }}
              icon={{
                type: "leading",
                icon: AddIcon,
              }}
              onClick={() => onAddChapterItem(item.chapterId, libTypeIds.MCQ)}
            />
            <Button
              size="sm"
              hierarchy={{ type: "linkGrey", buttonText: "Descriptive Test" }}
              icon={{
                type: "leading",
                icon: AddIcon,
              }}
              onClick={() =>
                onAddChapterItem(item.chapterId, libTypeIds.DESCRIPTIVE)
              }
            />
            <Button
              size="sm"
              hierarchy={{ type: "linkGrey", buttonText: "Coding Snippet" }}
              icon={{
                type: "leading",
                icon: AddIcon,
              }}
              onClick={() =>
                onAddChapterItem(item.chapterId, libTypeIds.CODING_SNIPPET)
              }
            />
            {
              getDataFromStorage("companyId") == 1 && (<Button
                size="sm"
                hierarchy={{ type: "linkGrey", buttonText: "Video Test" }}
                icon={{
                  type: "leading",
                  icon: AddIcon,
                }}
                onClick={() =>
                  onAddChapterItem(item.chapterId, libTypeIds.DESCRIPTIVE, false, true)
                }
              />)
            }
            <Button
              size="sm"
              hierarchy={{ type: "linkGrey", buttonText: "SQL Test" }}
              icon={{
                type: "leading",
                icon: AddIcon,
              }}
              onClick={() => onAddChapterItem(item.chapterId, libTypeIds.SQL)}
            />
            <Button
              size="sm"
              hierarchy={{ type: "linkGrey", buttonText: "Coding Test" }}
              icon={{
                type: "leading",
                icon: AddIcon,
              }}
              onClick={() =>
                onAddChapterItem(item.chapterId, libTypeIds.CODING_CHALLENGE)
              }
            />
            <Button
              size="sm"
              hierarchy={{ type: "linkGrey", buttonText: "Coding Challenge" }}
              icon={{
                type: "leading",
                icon: AddIcon,
              }}
              onClick={() =>
                onAddChapterItem(
                  item.chapterId,
                  libTypeIds.CODING_CHALLENGE,
                  true,
                )
              }
            />
          </div>
        )}
        <Modal
          isOpen={openModal}
          onClose={() => setOpenModal(false)}
          showCloseIcon={false}
          className="config-topic-confirmation-modal"
        >
          <ModalBody
            content={
              <>
                <p className="config-topic-confirmation-modal-title">
                  Delete Chapter
                </p>
                <p className="config-topic-confirmation-modal-content">
                  Are you sure you want to delete the chapter?
                </p>
              </>
            }
            footer={
              <div className="config-topic-confirmation-footer">
                <Button
                  size="sm"
                  hierarchy={{ type: "secondaryGrey", buttonText: "Cancel" }}
                  onClick={() => setOpenModal(false)}
                />
                <Button
                  size="sm"
                  hierarchy={{
                    type: "primary",
                    buttonText: isDeleting ? "Deleting" : "Delete",
                  }}
                  destructive={true}
                  disable={isDeleting}
                  onClick={() => onConfirmDeleteChapter(item)}
                />
              </div>
            }
          />
        </Modal>
      </Collapse>
    );
  },
);

export default Chapter;
